(function (window) {
    "use strict";
    function defineOrderHelper() {
        let orderHelper = {};
        orderHelper.orderStatus = {
            new: 1,
            pending: 2,
            accepted: 3,
            scheduledForDelivery: 4,
            scheduledDeliveryCancelled: 5,
            complete: 6,
            rejected: 7,
            cancelled: 8,
            onDelivery: 9,
            readyForCollection: 10,
            readyForUpliftment: 11,
            uplifted: 12
        };
        orderHelper.orderType = {
            delivery: 1,
            collection: 2,
            exTank: 3
        };
        orderHelper.specialPricingMethod = {
            customerPricingPerZone: 1,
            discountGroups: 2,
            depotDiscountGroups: 3
        };
        return orderHelper;
    }
    //define globally if it doesn't already exist
    if (typeof (orderHelper) === "undefined") {
        window.orderHelper = defineOrderHelper();
    } else {
        console.log("orderHelper already defined.");
    }
})(window);